import React from 'react';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import styles from '../../styles.module.scss';

type StatCardProps = {
    title: string;
    total: number;
    series: { index: number; count: number }[];
    color: string;
};

/*
 * A count + sparkline stat card used on the DAG and task Overview tabs
 */
export function StatCard({ title, total, series, color }: StatCardProps) {
    const gradientId = `statCardGradient-${title.replace(/\s+/g, '')}`;

    return (
        <div className={styles.metaField}>
            <div className={styles.metaLabel}>{title}</div>
            <div style={{ fontSize: 20, fontWeight: 600, color: '#e1e1e6' }}>{total}</div>
            <div style={{ height: 50 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={series}>
                        <defs>
                            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor={color} stopOpacity={0.35} />
                                <stop offset="100%" stopColor={color} stopOpacity={0.02} />
                            </linearGradient>
                        </defs>
                        <Area type="monotone" dataKey="count" stroke={color} strokeWidth={2} fill={`url(#${gradientId})`} dot={false} isAnimationActive={false} />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
